const Share = () => {
  return <></>;
};

export default Share;
